import { useTranslation } from 'react-i18next';
import { ButtonType } from '../../styled/theme/types';
import { Icon } from '../Icon';
import { StickyElement } from '../StickyElement';
import { Button } from '../ui/Button';
import {
  buttonStyles,
  PhoneBottomContainer,
  PhoneBottomLink,
  PhoneBottomWrapper
} from './styled';
import { phoneWithInternationalCode } from '../../utils/helpers/common';
import PhoneWhiteIcon from '../../public/static/images/phone_call_white-icon.svg';

interface StickyPhoneButtonProps {
  stat?: string;
  phones: string[] | null;
  isButtonSticky?: boolean;
  isOnePhone: boolean;
  isAgencyPage?: boolean;
  isCurrentItemPage?: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const StickyPhoneButton: React.FC<StickyPhoneButtonProps> = ({
  isAgencyPage = false,
  isCurrentItemPage = false,
  isOnePhone,
  stat,
  phones,
  isButtonSticky = true,
  onClick
}) => {
  const { t } = useTranslation();
  const isButtonGreen = isAgencyPage || isCurrentItemPage;

  return (
    <StickyElement bottomPos={true} bottomOffset={10}>
      {(isSticky, wrapperRef) => (
        <PhoneBottomContainer
          ref={wrapperRef}
          $isAgencyPage={isAgencyPage}
          $isCurrentItemPage={isCurrentItemPage}
        >
          <PhoneBottomWrapper
            $isSticky={isSticky && isButtonSticky}
            data-cy="bottom-phone__wrapper"
          >
            {!isOnePhone ? (
              <Button
                stat={stat}
                text={t('common.call')}
                cypress="bottom-phone"
                state={isButtonGreen ? ButtonType.green : ButtonType.default}
                onClick={onClick}
                styles={buttonStyles}
              >
                <Icon IconComponent={PhoneWhiteIcon} width={18} height={18} />
              </Button>
            ) : (
              <PhoneBottomLink
                href={`tel:${phoneWithInternationalCode(phones?.[0])}`}
                $isButtonGreen={isButtonGreen}
              >
                {t('common.call')}
              </PhoneBottomLink>
            )}
          </PhoneBottomWrapper>
        </PhoneBottomContainer>
      )}
    </StickyElement>
  );
};
